import React from "react";
import { Printer, CheckCircle } from "lucide-react";

interface Props {
  printers: string[];
  printer: string;
  setPrinter: (p: string) => void;
}

const PrinterListSection: React.FC<Props> = ({ printers, printer, setPrinter }) => {
  return (
    <section className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark transition">
      {/* === Header === */}
      <div className="border-b border-stroke dark:border-strokedark px-4 py-3 sm:px-5 xl:px-6 flex items-center gap-2">
        <Printer className="w-5 h-5 text-primary" />
        <h3 className="font-semibold text-black dark:text-white">
          Impresoras Detectadas
        </h3>
      </div>

      {/* === Body === */}
      <div className="p-4 sm:p-5 xl:p-6">
        {printers.length === 0 ? (
          <p className="text-sm text-gray-600 dark:text-gray-400">
            No se han detectado impresoras aún.
          </p>
        ) : (
          <ul className="space-y-2">
            {printers.map((p) => {
              const isSelected = p === printer;
              return (
                <li
                  key={p}
                  onClick={() => setPrinter(p)}
                  className={`cursor-pointer px-3 py-2 rounded-md border text-sm font-medium transition-colors
                    ${
                      isSelected
                        ? "bg-primary text-white border-primary"
                        : "border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-gray-700 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600"
                    }`}
                >
                  <div className="flex items-center justify-between">
                    <span className="truncate">{p}</span>
                    {isSelected && (
                      <CheckCircle className="w-4 h-4 text-white dark:text-white" />
                    )}
                  </div>
                </li>
              );
            })}
          </ul>
        )}

        {printer && (
          <div className="mt-4 text-sm text-gray-600 dark:text-gray-400 border-t border-stroke dark:border-strokedark pt-3">
            <strong className="font-medium text-black dark:text-white">
              Seleccionada:
            </strong>{" "}
            {printer}
          </div>
        )}
      </div>
    </section>
  );
};

export default PrinterListSection;
